
/* Native sections retain their own controls; normalise existing legacy disclosures. */
(() => {
 const controls='.zn-read-more-btn,[data-zm-inline-more]';
 const setup=()=>{
  document.querySelectorAll(controls).forEach(button=>{
   if(button.dataset.zmInlineReady)return;
   const owner=button.closest('.collection-hero__text-wrapper,.text-block,[data-description-panel]');
   const content=owner?.querySelector('.collection-hero__description,.description-content,[data-description-content]');
   if(!content)return;
   const children=[...content.childNodes];let paragraphs=0,cut=-1;
   children.forEach((node,index)=>{if(node.nodeType===1&&node.matches('p'))paragraphs++;if(paragraphs===2&&cut<0)cut=index;});
   if(cut<0||cut===children.length-1)return;
   const remainder=document.createElement('div');
   remainder.id='ZMInlineMore-'+document.querySelectorAll('[data-zm-inline-description]').length;
   remainder.hidden=true;
   children.slice(cut+1).forEach(node=>remainder.append(node));
   content.append(remainder);content.dataset.zmInlineDescription='';
   button.dataset.zmInlineReady='true';button.setAttribute('aria-controls',remainder.id);
   button.setAttribute('aria-expanded','false');
   if(button.tagName==='BUTTON')button.type='button';
   owner.append(button);
  });
 };
 document.addEventListener('click',event=>{
  const button=event.target.closest(controls);
  if(!button?.dataset.zmInlineReady)return;
  event.preventDefault();event.stopImmediatePropagation();
  const remainder=document.getElementById(button.getAttribute('aria-controls'));
  const open=button.getAttribute('aria-expanded')!=='true';
  remainder.hidden=!open;button.setAttribute('aria-expanded',String(open));
  button.textContent=open?'Read less ↑':'Read more ↓';
 },true);
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup,{once:true});else setup();
 document.addEventListener('shopify:section:load',setup);
})();
